import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { AlertsNotification, SkipNavContent, SkipNavLink, TYPES } from 'sarsaparilla';

import AutoLogoutWarning from '../containers/AutoLogoutWarning';
import Loading from '../containers/Loading';
import { logOut, navigateLogin } from '../actions/login';
import { getDomainsForLocation } from '../actions/fetchChildLocations';
import HeaderRibbon from '../components/HeaderRibbon';
import FooterRibbon from '../components/FooterRibbon';
import { parseUrlForLocation } from '../utilities//locations';

const propTypes = {
  history: TYPES.HISTORY,
  alerts: PropTypes.arrayOf(PropTypes.object),
  loggedInUser: PropTypes.object,
  selectedRole: PropTypes.object,
  logOut: PropTypes.func,
  navigateLogin: PropTypes.func,
  children: PropTypes.node,
  domainsForLocationId: PropTypes.object,
  getDomainsForLocation: PropTypes.func,
};

export class SiteWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.doLogOut = this.doLogOut.bind(this);
  }

  componentDidMount() {
    const location = parseUrlForLocation();
    if (location) {
      this.props.getDomainsForLocation(location, this.props.history);
    }
  }

  doLogOut() {
    this.props.logOut();
    this.props.navigateLogin();
  }

  handleLocationSelectorClick(e) {
    if (this._locationPicker) {
      this._locationPicker.handleSelectorClick(e);
    }
  }

  handleLocationClick(location) {
    this.props.getDomainsForLocation(location, this.props.history);
  }

  renderHeaderRibbon() {
    let role = null;
    if (this.props.loggedInUser) {
      role = this.props.selectedRole ? this.props.selectedRole : this.props.loggedInUser.roles[0];
    }

    let selectedLocation = null;
    if (this.props.selectedRole) {
      selectedLocation = this.props.selectedRole.location;
    } else if (this.props.loggedInUser && this.props.loggedInUser.roles.length === 1) {
      selectedLocation = this.props.loggedInUser.roles[0].location;
    }

    const doNav = window.location.pathname !== '/internal/account/hub';

    return (
      <HeaderRibbon
        history={this.props.history}
        user={this.props.loggedInUser}
        selectedRole={role}
        selectedLocation={selectedLocation}
        logout={this.doLogOut}
        navigateLogin={doNav ? this.props.navigateLogin : null}
        domainsForLocationId={this.props.domainsForLocationId}
        getDomainsForLocation={this.props.getDomainsForLocation}
        handleLocationSelectorClick={this.handleLocationSelectorClick.bind(this)}
      />
    );
  }

  render() {
    const classes = classNames({
      'page-wrapper': true,
      wrapper: true,
    });

    return (
      <div id="SiteWrapper" className={classes}>
        <SkipNavLink />
        <AutoLogoutWarning />
        <Loading />

        {this.renderHeaderRibbon()}

        <AlertsNotification alerts={this.props.alerts} />

        <SkipNavContent>
          <div className="site-body wrapper">{this.props.children}</div>
        </SkipNavContent>

        <FooterRibbon />
      </div>
    );
  }
}

SiteWrapper.propTypes = propTypes;

const mapStateToProps = (state) => {
  const loginDomains = state.login?.account?.domains_by_location_id || {};

  return {
    loggedInUser: state.login?.user,
    alerts: state.alertsNotification?.alerts,
    selectedRole: state.selectedLocationRole?.role,
    roleSelection: state.selectedLocationRole?.role,
    domainsForLocationId: state.fetchChildLocations?.selected_domains_by_location_id || loginDomains,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => {
      dispatch(logOut());
    },
    navigateLogin: () => {
      navigateLogin('/internal/account/hub');
    },
    getDomainsForLocation: (location, history) => dispatch(getDomainsForLocation(location, history)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiteWrapper));
